import React from "react";
import { RiLoader4Line } from "react-icons/ri";

function Loader({ loading }) {
  return (
    <>
      {loading && (
        <section className="loader">
          <div>
            <RiLoader4Line size={35} color="#e7c873" className="load" />
          </div>
        </section>
      )}
    </>
  );
}

export default Loader;
